import React, { Suspense, lazy } from 'react';
import { Hero } from './components/Hero';

/**
 * Carta de ventas progresiva: PROMESA → PROBLEMA → SOLUCIÓN → QUÉ INCLUYE →
 * DEMOSTRACIÓN → BONOS → PRECIO → RIESGO → OBJECIONES → COMPRA.
 *
 * Todo lo que está debajo del primer pantallazo se carga en chunks aparte para
 * que el Hero (LCP en mobile) llegue con el menor JS posible. Cada bloque
 * reserva altura mientras carga, así el CLS queda en cero.
 */
const ProblemSection = lazy(() => import('./components/ProblemSection').then(m => ({
  default: m.ProblemSection
})));
const SystemSection = lazy(() => import('./components/SystemSection').then(m => ({
  default: m.SystemSection
})));
const KitsSection = lazy(() => import('./components/KitsSection').then(m => ({
  default: m.KitsSection
})));
const InsideSection = lazy(() => import('./components/InsideSection').then(m => ({
  default: m.InsideSection
})));
const BonosSection = lazy(() => import('./components/BonosSection').then(m => ({
  default: m.BonosSection
})));
const OfferSection = lazy(() => import('./components/OfferSection').then(m => ({
  default: m.OfferSection
})));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const FaqSection = lazy(() => import('./components/FaqSection').then(m => ({
  default: m.FaqSection
})));
const FinalCta = lazy(() => import('./components/FinalCta').then(m => ({
  default: m.FinalCta
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const StickyBuyBar = lazy(() => import('./components/StickyBuyBar').then(m => ({
  default: m.StickyBuyBar
})));
interface DeferredProps {
  children: React.ReactNode;
  minHeight: string;
  background?: string;
}
function Deferred({
  children,
  minHeight,
  background = 'bg-ivory'
}: DeferredProps) {
  return <Suspense fallback={<div className={`w-full ${background}`} style={{
    minHeight
  }} aria-hidden data-id="element-1" data-mp="su427axbqqc2" />} data-id="element-0" data-mp="sunf2d84aoj8">
      {children}
    </Suspense>;
}
export function App() {
  return <main className="w-full bg-ivory text-charcoal" data-id="element-2" data-mp="38kvshhq5xim">
      {/* PROMESA */}
      <Hero data-id="element-3" data-mp="3uc9j1w993mja" />

      {/* PROBLEMA */}
      <Deferred minHeight="560px" background="bg-bone" data-id="element-4" data-mp="d4nwdiwxho3g">
        <ProblemSection data-id="element-5" data-mp="d45rxz0443kg" />
      </Deferred>

      {/* SOLUCIÓN */}
      <Deferred minHeight="560px" background="bg-charcoal" data-id="element-6" data-mp="851h73xjhxs0">
        <SystemSection data-id="element-7" data-mp="83qgxe3az85n" />
      </Deferred>

      {/* QUÉ INCLUYE */}
      <Deferred minHeight="1600px" data-id="element-8" data-mp="3gm61vjp8aj0p">
        <KitsSection data-id="element-9" data-mp="3gj1qo2dcin0j" />
      </Deferred>

      {/* DEMOSTRACIÓN VISUAL */}
      <Deferred minHeight="1050px" background="bg-bone" data-id="element-10" data-mp="3bo4n3ayu55v1">
        <InsideSection data-id="element-11" data-mp="3qbfx38fdcht1" />
      </Deferred>

      {/* BONOS */}
      <Deferred minHeight="1200px" data-id="element-12" data-mp="3qd0t72hc08t0">
        <BonosSection data-id="element-13" data-mp="3lk7m47ye4odr" />
      </Deferred>

      {/* PRECIO — primera revelación */}
      <Deferred minHeight="880px" background="bg-charcoal" data-id="element-14" data-mp="2xun3jq65ft50">
        <OfferSection data-id="element-15" data-mp="2xt24pocsxo1c" />
      </Deferred>

      {/* REDUCCIÓN DE RIESGO */}
      <Deferred minHeight="360px" background="bg-bone" data-id="element-16" data-mp="2sv0r3iy5agx9">
        <GuaranteeSection data-id="element-17" data-mp="18e1bbp26nwm5" />
      </Deferred>

      {/* OBJECIONES */}
      <Deferred minHeight="760px" data-id="element-18" data-mp="18boigguw01ub">
        <FaqSection data-id="element-19" data-mp="1d4zssrywr0qz" />
      </Deferred>

      {/* COMPRA */}
      <Deferred minHeight="700px" background="bg-bone" data-id="element-20" data-mp="1d6knchl82jou">
        <FinalCta data-id="element-21" data-mp="ygd5a2z4n2oo" />
      </Deferred>

      <Deferred minHeight="340px" data-id="element-22" data-mp="yhepoy2191j2">
        <Footer data-id="element-23" data-mp="13eevr8yvu4a6" />
      </Deferred>

      <Suspense fallback={null} data-id="element-24" data-mp="13fg95k3df2v2">
        <StickyBuyBar data-id="element-25" data-mp="13clpvvw3fo38" />
      </Suspense>
    </main>;
}